<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item :label="$t('userList.userName')" class="mb-0">
							<el-input size="small" v-model="from.name" ></el-input>
						</el-form-item>
						<el-form-item :label="$t('adminList.loginName')" class="mb-0">
							<el-input size="small" v-model="from.username"></el-input>
						</el-form-item>
						<el-form-item :label="$t('adminList.loginStatus')" class="mb-0">
							<el-select v-model="from.status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('status.enable')" :value="1"></el-option>
								<el-option :label="$t('status.disable')" :value="0"></el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item :label="$t('userList.buyStatus')" class="mb-0">
							<el-select v-model="from.buy_status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('userList.ok')" :value="1"></el-option>
								<el-option :label="$t('userList.no')" :value="0"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item v-if="layout.user.type==1" :label="$t('userList.agent')" class="mb-0">
							<el-select v-model="from.agent_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item :label="$t('adminList.createTime')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<div style="margin-top:10px">
						<el-button size="small" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('userList.addUser')}}</el-button>
					</div>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				<!-- <el-table-column align="center" type="index" :label="$t('adminList.sort')" width="50">
				</el-table-column> -->
				
				<el-table-column fixed="left" align="center" prop="id"  :label="$t('userList.id')" width="60">
				</el-table-column>
				<el-table-column align="center" prop="name" width="50" :label="$t('adminList.avatar')">
					<template slot-scope="scope">
						<el-image 
							style="width: 40px; height: 40px"
							:src="scope.row.head" 
							:preview-src-list="[scope.row.head]">
						</el-image>
					</template>
				</el-table-column>
				<el-table-column align="center" width="140" prop="name" :label="$t('userList.userName')">
				</el-table-column>
				<el-table-column align="center" prop="username" :label="$t('adminList.loginName')">
				</el-table-column>
				<el-table-column align="center" prop="status" width="90" :label="$t('adminList.loginStatus')">
					<template slot-scope="scope">
						<el-button
							:type="scope.row.status ? 'success' : 'danger'" 
							size="mini"
							@click="changeStatus(scope.row,'status')"
							plain>{{scope.row.status ? $t('adminList.normalLogin') : $t('adminList.forbidLogin')}}
						</el-button>
					</template>
				</el-table-column>
				
				<el-table-column align="center" prop="buy_status" :label="$t('userList.buyStatus')">
					<template slot-scope="scope">
						<el-button
							:type="scope.row.buy_status ? 'success' : 'danger'" 
							size="mini"
							@click="changeStatus(scope.row,'buy_status')"
							plain>{{scope.row.buy_status ? $t('userList.ok') : $t('userList.no')}}
						</el-button>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="agent_name" :label="$t('userList.agent')">
				</el-table-column>
				
				
				
				<el-table-column align="center" prop="pay_type" :label="$t('userList.pay_type')">
					
					<template slot-scope="scope">
						<span v-if="scope.row.pay_type==1">{{$t('userList.pay_type1')}}</span>
						<span v-if="scope.row.pay_type==2">{{$t('userList.pay_type2')}}</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="money" :label="$t('userList.money')">
				</el-table-column>
				<el-table-column width="140" align="center" prop="quota" :label="$t('userList.quotaHaveZ')">
					<template slot-scope="scope">
						<span class="">{{scope.row.quota}}</span>
						/
						<span class="text_chengse">{{scope.row.have_quota}}</span>
					</template>
				</el-table-column>
				
				<el-table-column width="120" align="center" prop="need_money" :label="$t('userList.need_money')">
					<template slot-scope="scope">
						<span class="text_chengse">{{scope.row.need_money}}</span>
					</template>
				</el-table-column>
				
				<!-- <el-table-column align="center" prop="have_quota" :label="$t('userList.quotaHave')">
					<template slot-scope="scope">
						<span class="text_chengse">{{scope.row.have_quota}}</span>
					</template>
				</el-table-column> -->
				
				
				<el-table-column align="center" prop="account_num" :label="$t('userList.have_account')">
					<template slot-scope="scope">
						<el-link @click="toAccount(scope.row.id)" type="primary" class="text_chengse">{{scope.row.account_num}}</el-link>
					</template>
				</el-table-column>
				
				<el-table-column align="center" prop="user_type" :label="$t('userList.userType')">
					<template slot-scope="scope">
						{{scope.row.user_type==1?$t('userList.userType1'):$t('userList.userType2')}}
					</template>
				</el-table-column>
				
				<el-table-column width="100" align="center" prop="odds" :label="$t('userList.odds')">
				
				</el-table-column>
				
				<el-table-column align="center" prop="warn_limit" :label="$t('userList.warn_limit')">
				</el-table-column>
				
				
				
				<el-table-column align="center" prop="remark" :label="$t('userList.remark')">
				</el-table-column>
				
				
				<el-table-column align="center" width="180" prop="create_time" :label="$t('adminList.createTime')">
				</el-table-column>
				
				<el-table-column align="center" width="180" prop="login_time" :label="$t('userList.loginTime')">
				</el-table-column>
				
				
				<el-table-column align="center" prop="email" :label="$t('userList.email')">
				</el-table-column>
				
				
				<el-table-column align="center" prop="phone" :label="$t('userList.phone')">
				</el-table-column>
				
				<el-table-column fixed="right" prop="id" align="center" :label="$t('adminList.operation')">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="primary" v-auth="'editAdmin'" @click="openModel(scope.row)">{{$t('adminList.operation')}}</el-button>
							<!-- <el-button @click="deleteItem(scope.row)" v-auth="'delAdmin'" size="mini" plain type="danger">{{$t('adminList.delete')}}</el-button> -->
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>



		<el-footer
		  class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		  :style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		  >
		   <div style="flex: 1;" class="px-2">
		    <el-pagination
		    :current-page="page.current"
		    :page-sizes="page.sizes"
		    :page-size="page.size"
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    background
		    :layout="layout.is_phone ? 'total, prev, pager, next, jumper' : 'total, prev, pager, next, sizes, jumper'"
		    :total="page.total"
		    />
		   </div>
		  </el-footer>

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('userList.editUser') : $t('userList.addUser')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				<el-form-item :label="$t('adminList.avatar')" prop="icon">
					<el-upload
						name="file"
						class="avatar-uploader"
						action="/admin/image/uploadNew"
						:headers="{token:$store.state.user.token}"
						:data="{type:'userHead'}"
						:show-file-list="false"
						:on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload">
						<img v-if="form.icon" :src="form.icon" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
				<el-form-item :label="$t('userList.userName')" prop="name">
					<el-input v-model="form.name" :placeholder="$t('userList.userName')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				<!-- <el-form-item :label="$t('adminList.belongTo')" prop="rule_id">
					<el-select v-model="form.rule_id" size="small" filterable :placeholder="$t('adminList.select')" style="width: 85%;">
						<el-option v-for="item in rule_list" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item :label="$t('adminList.loginName')" prop="username">
					<el-input :disabled="editIndex > -1" v-model="form.username" :maxlength="16" :minlength="6" :placeholder="$t('adminList.loginName')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
				</el-form-item>
				<el-form-item :label="$t('adminList.loginPassword')" prop="password">
					<el-input v-model="form.password" :maxlength="16" :minlength="6" show-password :placeholder="$t('adminList.loginPassword')" size="small" auto-complete="new-password" style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item :label="$t('adminList.confirmPassword')" prop="password2">
					<el-input v-model="form.password2" :maxlength="16" :minlength="6" show-password :placeholder="$t('adminList.confirmPassword')" size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item :label="$t('userList.userType')">
					<el-radio-group v-model="form.user_type" size="small">
						<el-radio :label="1" border>{{$t('userList.userType1')}}</el-radio>
						<el-radio :label="0" border>{{$t('userList.userType2')}}</el-radio>
					</el-radio-group>
				</el-form-item>
				
				<el-form-item v-if="layout.user.type==1" :label="$t('userList.agent')" prop="agent_id">
					<el-select :disabled="editIndex > -1" v-model="form.agent_id" size="small" filterable :placeholder="$t('system.select')">
						<el-option v-for="item in agentData" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('userList.pay_type')">
					<el-radio-group v-model="form.pay_type" size="small">
						<el-radio :label="1" border>{{$t('userList.pay_type1')}}</el-radio>
						<el-radio :label="2" border>{{$t('userList.pay_type2')}}</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item :label="$t('userList.buyStatus')">
					<el-radio-group v-model="form.buy_status" size="small">
						<el-radio :label="1" border>{{$t('userList.ok')}}</el-radio>
						<el-radio :label="0" border>{{$t('userList.no')}}</el-radio>
					</el-radio-group>
				</el-form-item>
				
				<el-form-item :label="$t('userList.quota')" prop="quota">
					<el-input v-model="form.quota" type="number" :placeholder="$t('userList.quota')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item :label="$t('userList.warn_limit')" prop="warn_limit">
					<el-input v-model="form.warn_limit" type="number" :placeholder="$t('userList.warn_limit')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item :label="$t('userList.odds')" prop="odds">
					<el-input v-model="form.odds" type="number" :placeholder="$t('userList.odds')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item :label="$t('userList.email')" prop="email">
					<el-input v-model="form.email" :placeholder="$t('userList.email')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item :label="$t('userList.phone')" prop="phone">
					<el-input v-model="form.phone" :placeholder="$t('userList.phone')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				<el-form-item :label="$t('userList.remark')" prop="remark">
					<el-input v-model="form.remark" :placeholder="$t('userList.remark')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
				<el-form-item :label="$t('adminList.loginStatus')">
					<el-radio-group v-model="form.status" size="small">
						<el-radio :label="1" border>{{$t('adminList.normalLogin')}}</el-radio>
						<el-radio :label="0" border>{{$t('adminList.forbidLogin')}}</el-radio>
					</el-radio-group>
				</el-form-item>
				
				
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submit">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				editIndex: -1,
				user_odds:0,
				//搜索數据
				from: {
					name: '',
					username:'',
					status:-1,
					agent_id:-1,
					buy_status:-1,
					time:[],
				},
				auth_val: 'Admin',

				preUrl: "user/userList", //列表地址
				delAllUrl: "user/delUserAll", //批量删除地址
				delUrl: "user/delUser", //删除單条地址
				addUrl: "user/addUser", //添加/修改地址
				editStatusUrl:"user/editStatusUser",//修改狀態地址
				agentData:[],
				tableData: [],
				form: {},
				rules: {
					name: [{
						required: true,
						message: this.$t('userList.nameRequired'),
						trigger: 'blur',
					}],
					username: [{
						required: true,
						message: this.$t('adminList.usernameRequired'),
						trigger: 'blur',
					}, {
						min: 6,
						max: 16,
						message: this.$t('userList.usernameLength'),
						trigger: 'blur'
					}],
					password: [{
						min: 6,
						max: 16,
						message: this.$t('adminList.passwordLength'),
						trigger: 'blur'
					}],
					agent_id: [{
						required: true,
						message: this.$t('userList.selAgent'),
						trigger: 'blur',
					}],
					odds: [{
						required: true,
						message: this.$t('userList.inpOdds'),
						trigger: 'blur',
					}],
				},
				rule_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList('agent');
		},
		methods: {
			toAccount(id){
				let checkUserAccount = {}
				checkUserAccount.name = id
				this.$router.push({
					name: 'account',
					params:{checkUserAccount:checkUserAccount}
				})
			},
			//提交
			submit() {
				if (this.form.password != this.form.password2) {
					this.$message({
						message: this.$t('adminList.differentPasswords'),
						type: 'error'
					});
					return
				}
				this.$refs.form.validate(res => {
					if(!this.form.headUrl){
						this.$message.error(this.$t('adminList.upProfile'));
						return false
					}
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},

			// 打开模态框
			openModel(e = false) { 
			    // 增加 
			    console.log(e) 
			    if (!e) { 
			     // 初始化表單 
			     this.form = { 
			      id:0, 
			      name: "", 
			      username: '', 
			      password: '', 
			      password2: '', 
			      headUrl: '', 
			      icon:'', 
			      status: 1, 
			      user_type:1, 
			      agent_id:'', 
			      buy_status:1, 
			      warn_limit:1000, 
			      pay_type:1, 
			      odds:this.user_odds, 
			      email:'', 
			      phone:'', 
			      quota:0, 
			      remark:'', 
			      headId: 0, 
			     } 
			     this.editIndex = -1 
			    } else { 
			     // 修改 
			     this.form = { 
			      id:e.id, 
			      name: e.name, 
			      username: e.username, 
			      password: '', 
			      password2: '', 
			      headUrl: e.head, 
			      icon:e.head, 
			      status: e.status, 
			      user_type:e.user_type, 
			      agent_id:e.agent_id, 
			      warn_limit:e.warn_limit, 
			      buy_status:e.buy_status, 
			      pay_type:e.pay_type, 
			      quota:e.quota, 
			      odds:e.odds, 
			      email:e.email, 
			      phone:e.phone, 
			      remark:'', 
			      headId: 0, 
			     } 
			     this.editIndex = e.id 
			    } 
			     
			    // 打开dialog 
			    this.createModel = true 
			   },
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.agentData = list.agent
					this.user_odds = list.user_odds
					console.log(res)
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
			
			    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'  || file.type === 'image/gif';
			    const isLt2M = file.size / 1024 / 1024 < 12;
			
			    if (!isJPG) {
			    this.$message.error(this.$t('message.info_err'));
			    }
			    if (!isLt2M) {
			    this.$message.error(this.$t('message.img_max_err'));
			    }
			    return isJPG && isLt2M;
			
			   },
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					username:'',
					status:-1,
					agent_id:-1,
					buy_status:-1,
					time:[],
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}
</style>
